export default "__VITE_ASSET__DE0in8qS__"